import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { HEADER_STATES } from 'src/app/shared/header/header.helper';
import WC_TYPES from 'src/app/types/written-communication-types';
import { APP_COLORS } from 'src/global-styles';
import { SneWrittenCommunicationBase } from '../sne-written-communication.base';

@Component({
  selector: 'ets-wc-multi-choice-memo',
  templateUrl: './wc-multi-choice-memo.component.html',
  styleUrls: ['./wc-multi-choice-memo.component.scss']
})
export class WcMultiChoiceMemoComponent extends SneWrittenCommunicationBase implements OnInit {

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  
  headerState = HEADER_STATES.BACK;
  APP_COLORS = APP_COLORS;
  WC_TYPES = WC_TYPES;

  singleResponseHandler(answer: string) {
    this.singleResponse = answer;
  }

  ngOnInit(): void {
    this.processParams();
  }

}
